import { PersonOutlineOutlined } from '@mui/icons-material';
import { Button, FormControl, FormControlLabel, FormLabel, Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField } from '@mui/material';
import moment from 'moment';
import React, { useState, useEffect } from "react";
import { SortableTableHead } from '../../components/helpers/tableSortableHeader';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { routerPath } from '../../config/constents';
import { getallRequestDetails, GetCorporateDashBoardData } from '../../Models/configapi';
import { useStateValue } from '../../providers/stateProvider';
import PDF from "../../assets/images/ExportPDF.png";
import Excel from "../../assets/images/ExportExcel.png";
import { downloadExcel } from "react-export-table-to-excel";
import { getDashBoard } from '../../Models/model';
import swal from 'sweetalert';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';


type Order = 'asc' | 'desc';

type Props = {
    bankId: number | string | undefined;
};

const Payout = () => {
    const navigate = useNavigate();
    const [{ user }, dispatch]: any = useStateValue();
    var date = new Date();
    let dateVal = moment(date).format("yyyy-MM-DD");
    let toDate = moment(date).format("yyyy-MM-DD");
    const [_value, _setValue] = useState<any>();
    const [_fromDate, _setFromDate] = useState<any>(dateVal);
    const [_toDate, _setToDate] = useState<any>(toDate);
    const [_dashBoardData, _setDashBoarddata] = useState<any>([]);
    const [_dashBoardDataCount, _setDashBoarddataCount] = useState<any>({});
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [_getdashData, _setDashdata] = useState<any>([]);
    const [page, setPage] = useState(0);
    const [query, setQuery] = useState("");
    const [_search, _setSearch] = useState("");
    const [_caseValue, _setCaseValue] = useState<any>("precase");
    const [_order, _setOrder] = useState<Order>('asc');
    const [_orderBy, _setOrderBy] = useState<string>('');
    const [buttonLoading, _setbuttonLoading] = useState(false);
    const [_statusVal, _setStatusVal] = useState<any>();
    const [progressPercentage, setprogressPercentage] = useState(0);


    const onRadioButtonChange = (e: any) => {
        if (e.target.value == 1) {
            _setValue(e.target.value);
            let todateVal = moment(date).format("yyyy-MM-DD");
            let fromDate = moment(date).format("yyyy-MM-DD");
            _setFromDate(fromDate);
            _setToDate(todateVal);
        }
        if (e.target.value == 2) {
            _setValue(e.target.value);
            let todateVal = moment(date).subtract(1, "days").format("yyyy-MM-DD");
            let fromDate = moment(date).subtract(1, "days").format("yyyy-MM-DD");
            _setFromDate(fromDate);
            _setToDate(todateVal);
        }
        if (e.target.value == 3) {
            _setValue(e.target.value);
            let fromDate = moment(date).format("yyyy-MM-DD");
            let todateVal = moment(date).add(7, "days").format("yyyy-MM-DD");
            _setFromDate(fromDate);
            _setToDate(todateVal);
        }
        if (e.target.value == 4) {
            _setValue(e.target.value);
            let fromDate = moment(date).format("yyyy-MM-DD");
            let todateVal = moment(date).add(30, "days").format("yyyy-MM-DD");
            _setFromDate(fromDate);
            _setToDate(todateVal);
        }
        if (e.target.value == 5) {
            _setValue(e.target.value);
            let todateVal = moment(date).format("yyyy-MM-DD");
            let fromDate = moment(date).subtract(1, "days").format("yyyy-MM-DD");
            _setFromDate(fromDate);
            _setToDate(todateVal);
        }
    };


    const getdashboardDet = () => {
        debugger;
        GetCorporateDashBoardData(user?.CorporateDetailsId)
            .then((response) => {
                console.log(response.data);
                _setDashdata(response.data.data);
            })
            .catch((error) => {
                console.log(error.response);
            });
    }
    useEffect(() => {
        console.log("Current Dashboard State:", _getdashData);
    }, [_getdashData]);
    const [formData, _setformData] = useState<any>({
        VendorId: 0,
        BankID: 0
    });

    // const handleSearch=(value:any)=>{
    //     _setSearchDt(value)
    // }

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        setPage(newPage);
    };

    const setFormValue = (name: string, value: any) => {
        _setformData({ ...formData, [name]: value });
    };

    const gotoNewRequest = () => {
        navigate(routerPath.newRequest)
    }

    const gotoPlan = () => {
        debugger;
        navigate(routerPath.plan.choosePlan)
    }

    const GetRequestDetails = (id: any) => {
        debugger;
        getallRequestDetails(0).then((res) => {
            debugger;
            if (res?.data?.status == "Success") {
                _setDashBoarddata(res?.data?.data)
                _setDashBoarddataCount(res?.data?.data?.length)
            }
        })
    }

    const handleDocDetails = (type: any, item: any) => {
        if (!(user?.BankId != null && user?.BankId != 0)) {
            return;
        }

        if (type === 'backOffice') {
            if (_caseValue === "precase") {
                navigate(routerPath.backoffice.precase + '?id=' + item?.Id)
            } else if (_caseValue === "postcase") {
                navigate(routerPath.backoffice.postcase + '?id=' + item?.Id)
            }
        } else if (type === 'qc') {
            if (_caseValue === "precase") {
                navigate(routerPath.qcTray.precase + '?id=' + item?.Id)
            } else if (_caseValue === "postcase") {
                navigate(routerPath.qcTray.postcase + '?id=' + item?.Id)
            }
        }
    }

    // const exportEXCEL = () => {
    //     debugger
    //     const header = ["Case No", "Reference No", "Bank Agency", "Customer Name", "MobileNumber", "Email"];
    //     let body: any = _dashBoardData.map((e: any) => { return [e.Caseno, e.BankReferenceNo, e.BankName, e.Name, e.MobileNumber, e.EmailId] })
    //     var curDate = moment()?.format("YYYY-MM-DD")
    //     var filename = 'DashBoardData_' + curDate;
    //     downloadExcel({
    //         fileName: filename,
    //         sheet: "DashBoardData",
    //         tablePayload: {
    //             header,
    //             body: body,
    //         },
    //     });
    // }

    const exportPDF = () => {

        const header = [[
            "Case No",
            "Ref No",
            "Customer Name",
            "Mobile Number",
            "Loan Amount",
            "Case Initiated",
            "Completed Percentage",
            "Completed Staff",
            "InCompleted Staff",
            "Status"
        ]];

        const filteredData = _dashBoardData.filter((content: any) =>
            (content.Caseno || "").toLowerCase().includes(query.toLowerCase()) ||
            (content.BankReferenceNo || "").toLowerCase().includes(query.toLowerCase()) ||
            (content.BankName || "").toLowerCase().includes(query.toLowerCase()) ||
            (content.Name || "").toLowerCase().includes(query.toLowerCase()) ||
            (content.MobileNumber || "").toLowerCase().includes(query.toLowerCase()) ||
            (content.EmailId || "").toLowerCase().includes(query.toLowerCase())
        );

        const body = filteredData.map((e: any) => {

            let status = "-";

            if (e.StatusId === 1) status = "Completed";
            else if (e.StatusId === 2) status = "Completed-TAT Breached";
            else if (e.StatusId === 3) status = "In Progress";
            else if (e.StatusId === 4) status = "In Progress-TAT Breached";
            else if (e.StatusId === 5) status = "Cancelled-Reassign";
            else if (e.StatusId === 8) status = "Verification Started";
            else if (e.StatusId === 9) status = "QC Pending";
            else if (e.StatusId === 10) status = "B.O Tray Pending";

            return [
                e.Caseno || "-",
                e.BankReferenceNo || "-",
                e.Name || "-",
                e.MobileNumber || "-",
                e.LoanAmount ? e.LoanAmount.toLocaleString() : "-",
                e.CreatedAt ? moment(e.CreatedAt).format("DD-MM-YYYY HH:mm:ss") : "-",
                `(${e.CompletedQty}/${e.OriginalQty}) ${Math.round((e.CompletedQty / e.OriginalQty) * 100)}%`,
                removeComma(e.CompletedFieldStaffs) || "-",
                removeComma(e.PendingFieldStaffs) || "-",
                status
            ];
        });

        const doc = new jsPDF();

        autoTable(doc, {
            head: header,
            body: body,
        });

        const curDate = moment().format("YYYY-MM-DD");
        const filename = "DashBoardData_" + curDate + ".pdf";

        doc.save(filename);
    };

    const exportEXCEL = () => {

        const header = [
            "Case No",
            "Ref No",
            "Customer Name",
            "Mobile Number",
            "Loan Amount",
            "Case Initiated",
            "Completed Percentage",
            "Completed Staff",
            "InCompleted Staff",
            "Status"
        ];

        const filteredData = _dashBoardData.filter((content: any) =>
            (content.Caseno || "").toLowerCase().includes(query.toLowerCase()) ||
            (content.BankReferenceNo || "").toLowerCase().includes(query.toLowerCase()) ||
            (content.BankName || "").toLowerCase().includes(query.toLowerCase()) ||
            (content.Name || "").toLowerCase().includes(query.toLowerCase()) ||
            (content.MobileNumber || "").toLowerCase().includes(query.toLowerCase()) ||
            (content.EmailId || "").toLowerCase().includes(query.toLowerCase())
        );

        const body: any = filteredData.map((e: any) => {

            let status = "-";

            if (e.StatusId === 1) status = "Completed";
            else if (e.StatusId === 2) status = "Completed-TAT Breached";
            else if (e.StatusId === 3) status = "In Progress";
            else if (e.StatusId === 4) status = "In Progress-TAT Breached";
            else if (e.StatusId === 5) status = "Cancelled-Reassign";
            else if (e.StatusId === 8) status = "Verification Started";
            else if (e.StatusId === 9) status = "QC Pending";
            else if (e.StatusId === 10) status = "B.O Tray Pending";

            return [
                e.Caseno || "-",
                e.BankReferenceNo || "-",
                e.Name || "-",
                e.MobileNumber || "-",
                e.LoanAmount ? e.LoanAmount.toLocaleString() : "-",
                e.CreatedAt ? moment(e.CreatedAt).format("DD-MM-YYYY HH:mm:ss") : "-",
                `(${e.CompletedQty}/${e.OriginalQty}) ${Math.round((e.CompletedQty / e.OriginalQty) * 100)}%`,
                removeComma(e.CompletedFieldStaffs) || "-",
                removeComma(e.PendingFieldStaffs) || "-",
                status
            ];
        });

        const curDate = moment().format("YYYY-MM-DD");
        const filename = "DashBoardData_" + curDate;

        downloadExcel({
            fileName: filename,
            sheet: "DashBoardData",
            tablePayload: {
                header,
                body
            }
        });
    };

    const handleRequestSort = (event: React.MouseEvent<unknown>, property: any) => {
        const isAsc = _orderBy === property && _order === 'asc';
        _setOrder(isAsc ? 'desc' : 'asc');
        _setOrderBy(property);
    };

    const removeComma = (value: any) => {
        var value1 = value.split(',').join(" ")
        return value1
    }

    // const onDashBoard = () => {
    //     _setbuttonLoading(true);
    //     setPage(0);

    //     const _formData = new FormData();

    //     _formData.append("VendorID", formData?.VendorId ? String(formData.VendorId) : "0");

    //     _formData.append("BankID", bankId ? String(bankId) : "0");
    //     _formData.append("StatusId", _statusVal ? String(_statusVal) : "0");

    //     _formData.append("StartDate", _fromDate);
    //     _formData.append("EndDate", _toDate);
    //     _formData.append("Type", _caseValue);

    //     _formData.append("UserId", user.id);

    //     const vCorporateDetailsId = user.CorporateDetailsId;

    //     getDashBoard(_formData, vCorporateDetailsId, user.roleName, bankId)
    //         .then((response) => {
    //             _setbuttonLoading(false);

    //             if (response.data.status === "Success") {

    //                 if (response.data.data !== "Data Not Found") {

    //                     setPage(0);

    //                     _setDashBoarddata(response.data.data.data);
    //                     _setDashBoarddataCount(response.data.data);

    //                     const total = response.data.data.TotalApplication || 0;
    //                     const completed = (response.data.data.Completed || 0) + (response.data.data.Completed_TATBreached || 0);

    //                     const percent = total ? (completed / total) * 100 : 0;

    //                     setprogressPercentage(percent);

    //                 } else {

    //                     _setDashBoarddata([]);
    //                     _setDashBoarddataCount({});
    //                     setprogressPercentage(0);

    //                 }
    //             }
    //         })
    //         .catch((error) => {

    //             _setbuttonLoading(false);
    //             _setDashBoarddata([]);
    //             _setDashBoarddataCount({});
    //             setprogressPercentage(0);

    //             console.log(error);

    //         });
    // };

    useEffect(() => {
        setPage(0);
    }, [_dashBoardData]);

    // useEffect(() => {

    //     if (bankId !== undefined) {
    //         onDashBoard();
    //     }

    // }, [bankId, _fromDate, _toDate]);

    useEffect(() => {
        setPage(0);
    }, [_dashBoardData]);
    return (
        <><div style={{ border: "1px solid #e1e7f0" }}>
            <div className="row">
                <div className="col-md-3">
                    <div className='d-flex'>
                        <FormLabel style={{ marginTop: '.8rem', whiteSpace: "nowrap" }} className="mx-2">
                            From Date
                        </FormLabel>
                        <TextField
                            className="mt-2"
                            id="date" autoComplete='off'
                            size="small"
                            label=" "
                            type="date"
                            defaultValue="2017-05-24"
                            value={_fromDate}
                            onChange={(e: any) => _setFromDate(e.target.value)}
                            InputLabelProps={{ shrink: false }}
                            style={{ border: 'none', outline: 'none' }} />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className='d-flex'>
                        <FormLabel style={{ marginTop: '.8rem' }} className="mx-2">
                            To Date
                        </FormLabel>
                        <TextField
                            className="mt-2"
                            id="date" autoComplete='off'
                            size="small"
                            label=" "
                            type="date"
                            defaultValue="2017-05-24"
                            value={_toDate}
                            onChange={(e: any) => _setToDate(e.target.value)}
                            InputLabelProps={{ shrink: false }} />
                    </div>
                </div>
                <div className="col-md-2"></div>
            </div>
        </div>


            <div className='gridView'>
                <div className="bg-primary py-2 mt-4 gx-0 text-white ps-3 row">
                    <div className="col-6 fs-4">Case List</div>
                    <div className="col-3">
                        <TextField
                            variant="outlined" autoComplete='off'
                            size="small"
                            label="Search" onChange={(e) => setQuery(e.target.value)}
                            className="text-white border border-white"
                        />
                    </div>
                    <div className="col-3">
                        <img
                            src={PDF}
                            alt=""
                            className="mx-5"
                            style={{ width: "3rem" }}
                            onClick={exportPDF}
                        />
                        <img
                            src={Excel}
                            alt=""
                            style={{ width: "3rem" }}
                            onClick={exportEXCEL}
                        />
                    </div>
                </div>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <SortableTableHead
                            order={_order}
                            orderBy={_orderBy}
                            onRequestSort={handleRequestSort}
                            headCells={[
                                { id: 'Caseno', label: 'Case No', align: 'left' },
                                { id: 'BankReferenceNo', label: 'Ref No', align: 'center' },
                                { id: 'Name', label: 'Customer Name', align: 'center' },
                                { id: 'MobileNumber', label: 'Mobile Number', align: 'center' },
                                { id: 'LoanAmount', label: 'Loan Amount', align: 'center' },
                                { id: 'CreatedAt', label: 'Case Initiated', align: 'center' },
                                { id: 'CompletedQty', label: 'Completed Percentage', align: 'center' },
                                { id: 'CompletedFieldStaffs', label: 'Completed Staff', align: 'center' },
                                { id: 'PendingFieldStaffs', label: 'InCompleted Staff', align: 'center' },
                                { id: 'StatusId', label: 'Status', align: 'center' },
                            ]}
                        />
                        <TableBody>
                            {_dashBoardData?.length
                                ? _dashBoardData.filter((content: any) =>
                                    (content.Caseno || "").toLowerCase().includes(query.toLowerCase()) ||
                                    (content.BankReferenceNo || "").toLowerCase().includes(query.toLowerCase()) ||
                                    (content.BankName || "").toLowerCase().includes(query.toLowerCase()) ||
                                    (content.Name || "").toLowerCase().includes(query.toLowerCase()) ||
                                    (content.MobileNumber || "").toLowerCase().includes(query.toLowerCase()) ||
                                    (content.EmailId || "").toLowerCase().includes(query.toLowerCase())
                                )
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item: any, index: any) => (
                                        <TableRow
                                            key={index}
                                            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">{item?.Caseno || "-"}</TableCell>
                                            <TableCell className="text-muted bolder text-nowrap" align="center">{item?.BankReferenceNo || "-"}</TableCell>
                                            <TableCell className="text-muted bolder" align="center">{item?.Name || "-"}</TableCell>
                                            <TableCell className="text-muted bolder text-nowrap" align="center">{item?.MobileNumber || "-"}</TableCell>
                                            {item?.LoanAmount ? (
                                                <TableCell className="text-muted bolder text-nowrap" align="center">{item?.LoanAmount.toLocaleString()}</TableCell>
                                            ) : (
                                                <TableCell className="text-muted bolder text-nowrap" align="center">{"-"}</TableCell>
                                            )}
                                            <TableCell className="text-muted bolder text-nowrap" align="center">{moment(item?.CreatedAt).format("DD-MM-yyyy hh:mm:ss") || "-"}</TableCell>
                                            <TableCell className="text-muted bolder text-nowrap" align="center">
                                                ({item?.CompletedQty + "/" + item?.OriginalQty})&nbsp; {Math.round((item?.CompletedQty / item?.OriginalQty) * 100)}%
                                            </TableCell>
                                            <TableCell className="text-muted bolder text-nowrap" align="center"> {removeComma(item?.CompletedFieldStaffs)}</TableCell>
                                            <TableCell className="text-muted bolder text-nowrap" align="center"> {removeComma(item?.PendingFieldStaffs)}</TableCell>
                                            {/* <TableCell align="center">{row.Status}</TableCell> */}
                                            <TableCell align="center">
                                                {item?.StatusId === 1 && (
                                                    <Button
                                                        variant="contained"
                                                        className="bg-success  bolder text-nowrap"
                                                        style={{ borderRadius: "10px" }}
                                                        type="submit"
                                                        onClick={() => handleDocDetails("qc", item)}
                                                    >
                                                        Completed
                                                    </Button>
                                                )}
                                                {item?.StatusId === 5 && (
                                                    <Button
                                                        variant="contained"
                                                        className="text-white px-4 py-2  bolder text-nowrap"
                                                        style={{ color: "yellowgreen", borderRadius: "10px" }}
                                                        type="submit"
                                                    >
                                                        Cancelled-Reassign
                                                    </Button>
                                                )}
                                                {item?.StatusId === 4 && (
                                                    <Button
                                                        variant="contained"
                                                        className="bg-danger px-2 py-2  bolder text-nowrap"
                                                        style={{ borderRadius: "10px" }}
                                                        type="submit"
                                                    >
                                                        In Progress-TAT Breached
                                                    </Button>
                                                )}
                                                {item?.StatusId === 2 && (
                                                    <Button
                                                        variant="contained"
                                                        className="bg-success  bolder text-nowrap"
                                                        style={{ borderRadius: "10px" }}
                                                        type="submit"
                                                    >
                                                        Completed-TAT Breached
                                                    </Button>
                                                )}
                                                {item?.StatusId === 3 && (
                                                    <Button
                                                        variant="contained"
                                                        className="text-white px-4 py-2  bolder text-nowrap"
                                                        style={{ color: "yellowgreen", borderRadius: "10px" }}
                                                        type="submit"
                                                        onClick={() => handleDocDetails("backOffice", item)}
                                                    >
                                                        In Progress
                                                    </Button>
                                                )}

                                                {item.StatusId === 8 && (
                                                    <Button
                                                        variant="contained"
                                                        className="bg-success px-4 "
                                                        type="submit"
                                                    >
                                                        Verification Started
                                                    </Button>
                                                )}
                                                {item.StatusId === 9 && (
                                                    <Button
                                                        variant="contained"
                                                        className="bg-warning px-4 text-nowrap "
                                                        style={{ borderRadius: "10px" }}
                                                        type="submit"
                                                        onClick={() => handleDocDetails("qc", item)}
                                                    >
                                                        QC Pending
                                                    </Button>
                                                )}
                                                {item.StatusId === 10 && (
                                                    <Button
                                                        variant="contained"
                                                        className="bg-warning px-4 text-nowrap "
                                                        style={{ borderRadius: "10px" }}
                                                        type="submit"
                                                        onClick={() => handleDocDetails("backOffice", item)}
                                                    >
                                                        B.O Tray Pending
                                                    </Button>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    )) : !_dashBoardData && (
                                        <TableRow key={0}>
                                            <TableCell align={"center"}>
                                                <h3 className="text-muted">Data Not Found</h3>
                                            </TableCell>
                                        </TableRow>
                                    )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>

    );
};

export default Payout;
